import { Button } from '@winnin/winnin_ui.components.button'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { useWinninAIReport } from 'contexts/WinninAIReportContext'
import { T, useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

const TOLGEE_PREFIX = 'GenerateWinninAIReportModal'

function NextButtonReport({ reportType, reportLanguage, isNotEligible, loading, isBlocked }) {
  const { winninAIReport, addWinninAIReportDetails } = useWinninAIReport()
  const t = useTranslate()

  const isWinner = UserStore?.userInfo?.company?.id === 'WINNIN'
  const shouldBlockButton = isWinner ? false : isBlocked

  function handleNextClick() {
    analyticsTracker.eventTrack('AI Report Modal Next Click', {
      id: winninAIReport?.id,
      entity: winninAIReport?.entity,
      type: reportType,
    })
    addWinninAIReportDetails(reportType, reportLanguage)
  }

  return (
    <TooltipWrapper
      tooltipMessage={
        !!isNotEligible && !loading
          ? t({
              ...TOLGEE_GLOBALS.notEligibleWinninAIReport,
              parameters: { type: reportType },
            })
          : ''
      }
      tooltipStyle="tooltippedN"
      isTooltipMultiline
    >
      <Button onClick={handleNextClick} disabled={isNotEligible || loading || shouldBlockButton}>
        <T keyName={`${TOLGEE_PREFIX}-modalNext`}>Próximo</T>
      </Button>
    </TooltipWrapper>
  )
}

export default NextButtonReport
